import { noop } from 'lodash-es';
import { call, put, takeLatest } from 'redux-saga/effects';
import { setActionLoaderFalse, setActionLoaderTrue } from '../../reducers/actionLoader';
import {
	getMarginInfo,
	modify_oneTime_order,
	placeOneTimeOrder,
	placeSipOrder,
	fetch_order_scrip_data,
	fetch_brokerage_charges,
} from '../../../apis/equity/orderForm';
import { setError } from "../../reducers/error";
import { setLoader } from "../../reducers/loader";
import {
	fetchMarginInfo,
	fetchOrderScripData,
	modifyOneTimeOrder,
	updateOneTimeOrder,
    updateSipOrder,
	fetchBrokerageCharges,
} from '../../reducers/equity/orderForm';

function* handleUpdateOneTimeOrders({ payload }) {
	const { screen, data, sagaCallBack = noop, Api } = payload;
	try {
		yield put(setLoader({ screen, isButtonLoading: true }));
		yield put(setError({ screen, isUpdateFailed: false }));
		const response = yield call(placeOneTimeOrder, data, Api);

		yield call(sagaCallBack, response.data);
	} catch (error) {
		console.log('Error - place one time order:', error);
		yield call(sagaCallBack, {}, error.message);
		yield put(setError({ screen, isUpdateFailed: true, message: error.message }));
	} finally {
		yield put(setLoader({ screen, isButtonLoading: false }));
	}
}

function* handleUpdateSipOrders({ payload }) {
	const { screen, data, sagaCallBack = noop, Api, token = '' } = payload;
	try {
		yield put(setLoader({ screen, isButtonLoading: true }));
		yield put(setError({ screen, isUpdateFailed: false }));
		const response = yield call(placeSipOrder, data, token, Api);

		yield call(sagaCallBack, response.status);
	} catch (error) {
		console.log('Error - place sip order:', error.message);
		yield call(sagaCallBack, {}, error.message);
		yield put(setError({ screen, isUpdateFailed: true, message: error.message }));
	} finally {
		yield put(setLoader({ screen, isButtonLoading: false }));
	}
}

function* handleModifyOneTimeOrders({ payload }) {
	const { screen, exchange, orderID, data, sagaCallBack = noop, Api, token = '' } = payload;

	try {
		yield put(setLoader({ screen, isButtonLoading: true }));
		yield put(setError({ screen, isUpdateFailed: false }));
		const response = yield call(modify_oneTime_order, exchange, orderID, data, token, Api);

		yield call(sagaCallBack, response.data);
	} catch (error) {
		console.log('Error - modify one time order:', error);
		yield call(sagaCallBack, {}, error.message);
		yield put(setError({ screen, isUpdateFailed: true, message: error.message }));
	} finally {
		yield put(setLoader({ screen, isButtonLoading: false }));
	}
}
// new
function* handleFetchMarginInfo({ payload }) {
	const { data = {}, sagaCallBack = noop, token = '', Api } = payload;

	try {
		const response = yield call(getMarginInfo, data, token, Api);
		yield call(sagaCallBack, response.data.result);
	} catch (error) {
		yield call(sagaCallBack, {});
		console.log('Error - margin info:', error);
	}
}

function* handleFetchOrderScripData({ payload }) {
	const { param = {}, token = '', sagaCallBack = noop, Api } = payload;
	try {
		yield put(setActionLoaderTrue(fetchOrderScripData));
		const response = yield call(fetch_order_scrip_data, param, token, Api);
		const scripData = response.data;
		yield call(sagaCallBack, scripData);
	} catch (error) {
		yield call(sagaCallBack, {}, error.message);
	} finally {
		yield put(setActionLoaderFalse(fetchOrderScripData));
	}
}

function* handleFetchBrokerageCharges({ payload }) {
	const {Api, params={}, sagaCallBack = noop} = payload;
	try {
      yield put(setActionLoaderTrue(fetchBrokerageCharges));
	  const response = yield call(fetch_brokerage_charges, Api, params);
      yield call(sagaCallBack, response);
	} catch (error) {
     console.log('Error - fetch brokerage charges:', error);
	 yield call(sagaCallBack, {}, error.message);
	} finally {
     yield put(setActionLoaderFalse(fetchBrokerageCharges));
	}
}

export default function* sagaBuySell() {
	yield takeLatest(updateOneTimeOrder.toString(), handleUpdateOneTimeOrders);
	yield takeLatest(updateSipOrder.toString(), handleUpdateSipOrders);
	yield takeLatest(fetchMarginInfo.toString(), handleFetchMarginInfo);
	yield takeLatest(modifyOneTimeOrder.toString(), handleModifyOneTimeOrders);
	yield takeLatest(fetchOrderScripData.toString(), handleFetchOrderScripData);
	yield takeLatest(fetchBrokerageCharges.toString(), handleFetchBrokerageCharges);
}
